"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReconCostController = function ReconCostController() {
  (0, _classCallCheck3.default)(this, ReconCostController);
};

exports.default = ReconCostController;


// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleAppraisal/reconCost/reconCost.controller.js